<template>
  <section>
    <div class="role">
      <div class="roleRight" style="overflow-x: hidden">
        <div class="roleRight_Top" style="margin-bottom:20px;display: block" v-if="searchShow">
          <el-input
              clearable
              v-model="search.searchKey"
              clas="input_search"
              placeholder="搜索关键字"
              style="margin-bottom: 10px;margin-right: 10px"
              @keyup.enter.native="searchFileList"
          ></el-input>
          <el-select
              v-model="search.fileType"
              clearable
              filterable
              placeholder="类型"
              style="margin-bottom: 10px;margin-right: 10px"
          >
            <el-option
                v-for="item in EventIdentification"
                :key="item.key"
                :label="item.name"
                :value="item.key"
            ></el-option>
          </el-select>
          <el-select
              v-model="search.status"
              clearable
              filterable
              style="margin-bottom: 10px;margin-right: 10px"
              placeholder="状态">
            <el-option
                v-for="item in CallbackStatus"
                :key="item.key"
                :label="item.name"
                :value="item.key"
            ></el-option>
          </el-select>
          <el-button size="medium" type="primary" @click="searchFileList">查询
          </el-button>
        </div>
        <div class="public-table-data">
          <el-table
              :data="tableData"
              size="medium"
              border
              style="width: 100%"
              row-key="customerServiceId"
              v-loading="loading"
          >
            <el-table-column fixed label="序号" type="index" width="50">
              <template slot-scope="scope">
                <span>{{scope.$index+1}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="fileTypeName" label="类型" min-width="100"> </el-table-column>
            <el-table-column prop="fileName" label="名称" min-width="280"></el-table-column>
            <el-table-column prop="fileSuffix" label="后缀" min-width="50"></el-table-column>
            <el-table-column prop="channelAccount" label="条件时间" min-width="310">
              <template slot-scope="scope">
                <span>
                  {{scope.row.startTime}}-{{scope.row.endTime}}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="ctime" label="创建时间" min-width="160"></el-table-column>
            <el-table-column prop="finishTime" label="导出时间" min-width="160"></el-table-column>
            <el-table-column prop="status" label="状态" min-width="80">
              <template slot-scope="scope">
                <span>{{scope.row.status==0?'导出中':scope.row.status==1?'导出成功':'导出失败'}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="callbackTime" label="导出条件" min-width="80">
              <template slot-scope="scope">
                <span @click="showCondition(scope.row)" style="cursor: pointer">查看</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="创建人" min-width="100"> </el-table-column>
            <el-table-column prop="paymentType" fixed="right"  label="操作">
              <template slot-scope="scope">
                <el-button v-if="downShow" type="primary" @click="DowlonFile(scope.row.filePath)" size="small" plain>下载</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="roleRight_pagenation">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page.pageNo"
              :page-sizes="[PAGE_SIZE, 15, 20, 25]"
              :page-size="page.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="page.count"
          >
          </el-pagination>
        </div>
      </div>
      <el-dialog
          title="提示"
          :visible.sync="dialogVisible"
          width="30%"
          center
          >
        <div>{{conditionTxt}}</div>
      </el-dialog>
    </div>
  </section>
</template>
<script>
import {PAGE_SIZE} from "@/config";

export default {
  data() {
    return {
      PAGE_SIZE,
      EventIdentification: [
        {
          key: 'examorder',
          name: '测评订单'
        },
        {
          key: 'channelcallback',
          name: '渠道回传'
        },
        {
          key: 'feedback',
          name: '意见反馈'
        },
        {
          key: 'orderpay',
          name: '支付订单'
        },
        {
          key: 'user',
          name: '用户列表'
        },
        {
          key: 'viporder',
          name: '会员订单'
        },
        {
          key: 'tarotorder',
          name: '塔罗订单'
        },
        {
          key: 'guoxueorder',
          name: '国学订单'
        },
      ],
      CallbackStatus: [
        {
          key: '0',
          name: '导出中'
        },
        {
          key: '1',
          name: '导出成功'
        },
        {
          key: '2',
          name: '导出失败'
        },
      ],
      search:{
        searchKey:'',
        status:'',
        fileType:''
      },
      // 分页
      page: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
      },
      tableData: [], //顶顶那列表
      dialogVisible:false,
      conditionTxt:{},
      searchShow: false,
      downShow: false,
    };
  },
  created() {
    this.getserviceList();
    this.getPermissionButtonList()
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.params = {};
      }
    },
  },
  methods: {
    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton')
      let arr = JSON.parse(PermissionButtonList)
      if (arr.length) {
        arr.map(item => {
          if (item.code == 'downcsv:file:query') {
            this.searchShow = true
          }
          if (item.code == 'downcsv:file:down') {
            this.downShow = true
          }
        })
      }
    },

    DowlonFile(e){
      if(e){
        window.open(e)
      }
    },
    showCondition(e){
      this.conditionTxt = JSON.parse(e.exportParams)
      this.dialogVisible = true
    },
    searchFileList(){
      this.page.pageNo = 1
      this.getserviceList()
    },
    //订单列表
    async getserviceList(e) {
      this.loading = true;
      const {data: res} = await this.$get(
          `/export/file/list`,
          {params: {...this.search, ...this.page}},
          {
            headers: {
              isLoading: true,
            },
          }
      );
      this.loading = false;
      this.tableData = res.data;
      this.page.count = res.page.count;
    },
    //分页
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getserviceList();
    },
    handleCurrentChange(val) {
      this.page.pageNo = val;
      this.getserviceList();
    },
  },
};
</script>

<style lang="scss" scoped>
.role {
  display: flex;
  gap: 20px;
  color: #666; /** 公共的黑色 --暂定 */
  font-size: 14px;

  &Right {
    flex: 1;
    display: flex;
    flex-direction: column;

    &_Top {
      display: flex;
      gap: 15px;

      .el-input {
        width: auto;
      }

      .timeblock {
        display: flex;
        box-sizing: border-box;
        background: #fff;
        border: 1px solid #dcdfe6;
        border-radius: 5px;

        .cla ::v-deep .el-input--suffix .el-input__inner {
          padding-right: 0;
        }

        ::v-deep .el-input__inner {
          border: none !important;
          height: 38px;
        }
      }
    }

    &_Container {
      margin-top: 20px;
    }

    &_pagenation {
      margin: 40px auto;
    }

    ::v-deep .el-table th,
    ::v-deep .el-table td {
      text-align: center !important;
    }
  }
}

</style>

<style scoped>
</style>